export class Tracking {
	ga = null;
	constructor(providers) {
		if (providers) {
			const { ga } = providers;
			this.ga = ga;
		}
	}
	pageView = ({ location, title }) => {
        if(!location) {
            location = window.location.pathname;
        }
		console.debug(`Tracking - Page view`, {
			title,
			location,
		});
		if (this.ga) {
			this.ga.pageview(location, undefined, title);
		}
	};

	event = ({ category, action, label, value }) => {
		console.debug('Tracking - Event', {
			category,
			action,
			label,
			value,
		});
		if (this.ga) {
			this.ga.event({
				category,
				action,
                label,
                value
			});
		}
	};
}
